export function getMatchScore(text: string, query: string): number {
  text = text.toLowerCase();
  query = query.toLowerCase();

  if (text.startsWith(query)) {
    return 0;
  }

  const index = text.indexOf(query);
  if (index !== -1) {
    return index + 1;
  }

  return Infinity;
}
